import React, { useContext, useMemo } from "react";
import { useGetPOIProjectsQuery } from "../../../Redux/service/POIS/POIs";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import trans from "../../../utils";
import { useGetSubmittalsEnumsQuery } from "../../../Redux/service/Submittals/Submittals";
import { InputDate, TextAreaInput } from "../../Helpers/Input/Input";
import dayjs from "dayjs";
import Dropfile from "../../Helpers/Dropzone/Dropzone";
import { popupcontext } from "../../../context/Popupscontext";

export default function SubmittalInfo({
	addData,
	isEditing,
	attachments,
	isLoading,
}) {
	const { data: projects } = useGetPOIProjectsQuery();
	const { data } = useGetSubmittalsEnumsQuery();
	let { resubmission } = useContext(popupcontext);
	const { typeOptions, disciplineOptions } = useMemo(() => {
		if (!data?.data)
			return { typeOptions: [], disciplineOptions: [], statusOptions: [] };

		const { SubmittalType, SubmittalDiscipline, SubmittalStatus } = data.data;
		const convertToOptions = (obj) =>
			Object.entries(obj).map(([key, value]) => ({
				label: trans(value),
				value: key,
			}));

		return {
			typeOptions: convertToOptions(SubmittalType),
			disciplineOptions: convertToOptions(SubmittalDiscipline),
			statusOptions: convertToOptions(SubmittalStatus),
		};
	}, [data]);
	return (
		<>
			<p className="fs-16 fw-500 brand-700 text-capitalize">
				{trans("general information")}
			</p>
			<div className="row">
				{!isEditing && (
					<div className="col-lg-6">
						<InputSelect
							label="projects"
							name="projectId"
							id="projectId"
							options={projects?.data?.map((i) => ({
								label: i.name,
								value: i.id,
							}))}
							placeholder={trans(`Select Project`)}
							formstyle="form-input"
							onBlur={(e) => addData.handleBlur(e)}
							onChange={(value) => addData.setFieldValue("projectId", value)}
							value={addData.values.projectId}
							allowClear={false}
							touched={addData.touched.projectId}
							errors={addData.errors.projectId}
							disabled={resubmission}
						/>
					</div>
				)}
				<div className="col-lg-6">
					<InputSelect
						label="Type"
						name="type"
						id="type"
						placeholder={trans("Select Type")}
						options={typeOptions}
						formstyle="form-input"
						onBlur={(e) => addData.handleBlur(e)}
						onChange={(value) => addData.setFieldValue("type", value)}
						value={addData.values.type}
						allowClear={false}
						touched={addData.touched.type}
						errors={addData.errors.type}
						disabled={resubmission}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="discipline"
						name="discipline"
						id="discipline"
						placeholder={trans("Select Discipline")}
						options={disciplineOptions}
						formstyle="form-input"
						onBlur={(e) => addData.handleBlur(e)}
						onChange={(value) => addData.setFieldValue("discipline", value)}
						value={addData.values.discipline}
						allowClear={false}
						touched={addData.touched.discipline}
						errors={addData.errors.discipline}
						disabled={resubmission}
					/>
				</div>
				<div className="col-lg-6">
					<InputDate
						title={trans("Review Date")}
						id="targetReviewDate"
						name="targetReviewDate"
						onBlur={(value) =>
							addData.setFieldTouched("targetReviewDate", true)
						}
						onChange={(value) => {
							const formattedDate = value
								? dayjs(value).format("YYYY-MM-DD")
								: "";
							addData.setFieldValue("targetReviewDate", formattedDate);
						}}
						errors={addData.errors.targetReviewDate}
						touched={addData.touched.targetReviewDate}
						value={addData.values.targetReviewDate || ""}
						disabled={resubmission}
					/>
				</div>
				<div className="col-lg-12 mb-5">
					<TextAreaInput
						title={trans("Description")}
						type="text"
						placeholder={trans("Enter your description")}
						formstyle="form-input"
						id="description"
						name="description"
						rows={3}
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.description}
						touched={addData.touched.description}
						value={addData.values.description || ""}
						disabled={resubmission}
					/>
				</div>
				<div className="col-lg-12">
					<Dropfile
						addData={addData}
						EditableAttachments={attachments}
						name="attachments"
						totalfiles={10}
						totalsize={250}
						maxtotalsize={50 * 1024 * 1024}
						isLoading={isLoading}
					/>
				</div>
				{resubmission && (
					<TextAreaInput
						title={trans("Resubmission Comments")}
						rows={3}
						placeholder={trans("Enter your comments")}
						id="comments"
						name="comments"
						onChange={(e) => addData.handleChange(e)}
						onBlur={(e) => addData.handleBlur(e)}
					/>
				)}
			</div>
		</>
	);
}
